export const generateCodeScript = (tagUrl: string, domainHashCode: string) => {
  return `<script async src="https://${
    tagUrl || ''
  }/i/${domainHashCode}.js" class="ct_clicktrue"></script>`
}

export const generateNoScriptCode = (tagUrl: string, domainHashCode: string) => {
  return `<noscript><iframe src="https://${
    tagUrl || ''
  }/ns/${domainHashCode}.html?ch=" width="0" height="0" style="display:none"></iframe></noscript>`
}

export const generateGtmNoScriptUrl = (tagUrl: string, domainHashCode: string) => {
  return `https://${tagUrl || ''}/ns/${domainHashCode}.html?ch=`
}
